<template>
  <div>
    <Crumbs></Crumbs>
    <div class="mainList">
      <div class="mainList_operation clearfloat">
        <div class="mainList_operation_search">
			<el-row type="flex" justify="left" :gutter="5">
				  <el-col :span="3">
					<el-select size="large"  v-model="parameter.type" placeholder="姓名">
					 <el-option  v-for="item in s_title" :key="item.value" :label="item.text" :value="item.value">
					  </el-option>
					<!--  <el-option  style="height:40px;"value="姓名">
					  </el-option>
					  <el-option  style="height:40px;"value="邮箱">
					  </el-option> -->
					</el-select>
				  </el-col>
				    <el-col :span="6">
						 <el-input
							class="item"
							placeholder="请输入"
							clearable
							v-model="parameter.nickname"
						  ></el-input>
					 </el-col>
		  		<el-col :span="9">
				  <el-input
					class="item"
					placeholder="请输入手机号"
					clearable
					v-model="parameter.mobile"
				  ></el-input>
		  	  </el-col>
			 <el-col :span="6">
				  <el-button
					type="primary"
					plain
					icon="el-icon-search"
					@click="pageChangeHandler(1)"
					>搜索</el-button
				  >
			</el-col>
		  </el-row>
        </div>
        <div class="fr">
	
          <el-button type="primary" icon="el-icon-plus" @click="add"
            >新增</el-button
          >
		  <el-button type="danger" icon="el-icon-dec" @click="p_del"
		    >删除</el-button
		  >
        </div>
      </div>
      <div class="mainList_content">
        <ReceivingAddress :options="activeData">
          receivingAddress
        </ReceivingAddress>
        <div class="mainList_content_sub">
          <el-table
            ref="multipleTable"
            border
            :data="tableData"
            tooltip-effect="dark"
            height="string"
            v-loading="loading"
			@select="selectionGood"
          >
		  <el-table-column align="center" type="selection" width="55">
		  </el-table-column>
            <el-table-column
              label="序号"
              type="index"
              align="center"
              width="70"
            ></el-table-column>
     <!--       <el-table-column
              align="center"
              prop="nickname"
              label="昵称"
            ></el-table-column> -->
			<el-table-column
			  align="center"
			  prop="true_name"
			  label="姓名"
			></el-table-column>
			<el-table-column
			  align="center"
			  prop="area"
			  label="地区"
			></el-table-column>
			<el-table-column
			  prop="company_name"
			  align="center"
			  label="机构"
			></el-table-column>
			<el-table-column
			  prop="department"
			  align="center"
			  label="部门"
			></el-table-column>
			<el-table-column
			  prop="cultural_title"
			  align="center"
			  label="职位"
			></el-table-column>
            <el-table-column
              align="center"
              prop="mobile"
              label="手机号"
            ></el-table-column>
			<el-table-column
			  align="center"
			  prop="email"
			  label="邮箱"
			></el-table-column>
			<el-table-column
			  align="center"
			  prop="create_time"
			  label="创建时间"
			></el-table-column>
<!--            <el-table-column align="center" prop="user_level" label="身份类型">
              <template slot-scope="scope">
                <div>{{ scope.row.get_user_level.name }}</div>
                <div v-if="scope.row.get_user_level.user_level_id !== 1">
                  会员有效期：{{
                    $dayjs(scope.row.level_start_time * 1000).format(
                      'YYYY-MM-DD HH:mm'
                    )
                  }}
                  至
                  {{
                    $dayjs(scope.row.level_end_time * 1000).format(
                      'YYYY-MM-DD HH:mm'
                    )
                  }}
                </div>
              </template>
            </el-table-column> -->
      
        
            <!-- <el-table-column align="center" prop="sex" label="性别">
              <template slot-scope="scope">
                {{  scope.row.sex | sex  }}
              </template>
            </el-table-column> -->
            <el-table-column
              label="操作"
              align="center"
              width="160"
              fixed="right"
            >
              <template slot-scope="scope">
       <!--         <el-button
                  type="text"
                  size="small"
                  @click="activeData = scope.row"
                  >收货地址</el-button
                >
                <el-button type="text" size="small" @click="edit(scope)"
                  >编辑</el-button
                > -->
                <el-button
                  type="text"
                  size="small"
                  class="danger"
                  @click="del(scope)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="pageChangeHandler"
            :current-page.sync="parameter.page_no"
            :page-size="parameter.page_size"
            prev-text="上一页"
            next-text="下一页"
            :total="parameter.total_result"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <Edit :isShow.sync="showEditDialog" :options="options"></Edit>
  </div>
</template>
<script>
export default {
  components: {
    ReceivingAddress: () => import('./ReceivingAddress.vue'),
    Edit: () => import('./Edit.vue'),
    Crumbs: () => import('@/components/Crumbs.vue'),
  },
  data() {
    return {
      parameter: {
        method: 'get.user.list',
        page_no: 1,
        page_size: 50,
        total_result: 0,
      },
      activeData: {},
      options: {},
      tableData: [],
      loading: false,
      showEditDialog: false,
	  ids:[],
	  s_title:[
		       { text: '姓名', value: '1' },
				{ text: '地区', value: '2' },
		        { text: '机构', value: '3' },
				    { text: '部门', value: '4' },
					    { text: '职位', value: '5' },
						    { text: '邮箱', value: '6' },
	
		  ]
    }
  },
  provide() {
    return {
      refresh: this.refresh,
    }
  },
  watch: {},
  created() {
    this.getData()
  },
  methods: {
	 selectionGood(e) {
		 let arr = e;
		 const uniqueArr = [];
		 const ids = [];
		 for (let i = 0; i < arr.length; i++) {
		   const item = arr[i];
		   
		     ids.push(item.user_id);
		   
		 }
		 this.ids = ids;
		 
	    console.log(ids);
	  },
    refresh() {
      this.showEditDialog = false
      this.pageChangeHandler(1)
    },
    pageChangeHandler(val) {
      this.parameter.page_no = val
      this.getData()
    },
    handleSizeChange(val) {
      this.parameter.page_size = val
      this.parameter.page_no = 1
      this.getData()
    },
    edit(scope) {
      this.options = scope.row
      this.showEditDialog = true
    },
    add() {
      this.options = {}
      this.showEditDialog = true
    },
    getData() {
		console.log(this.parameter);
      this.loading = true
      this.$api.user
        .user(this.parameter)
        .then((res) => {
          this.loading = false
          this.tableData = res.data.items
          this.parameter.total_result = res.data.total_result
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
        })
    },
    del(scope) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$api.user
            .user({
              module: 'admin',
              method: 'del.user.list',
              'client_id[]': scope.row.user_id,
            })
            .then((res) => {
              this.$message.success('删除成功！')

              var hasLastPage =
                this.parameter.page_size * this.parameter.page_no >=
                this.parameter.total_result
              var lastData = this.tableData.length < 2
              if (lastData && hasLastPage && this.parameter.page_no > 1) {
                this.parameter.page_no--
              }
              this.getData()
            })
            .catch((err) => {
              console.log(err)
            })
        })
        .catch(() => {
          //用户取消
        })
    },
   p_del() {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
			
          this.$api.user
            .user({
              module: 'admin',
              method: 'del.user.list',
              'client_id': this.ids,
            })
            .then((res) => {
              this.$message.success('删除成功！')
  
              var hasLastPage =
                this.parameter.page_size * this.parameter.page_no >=
                this.parameter.total_result
              var lastData = this.tableData.length < 2
              if (lastData && hasLastPage && this.parameter.page_no > 1) {
                this.parameter.page_no--
              }
              this.getData()
            })
            .catch((err) => {
              console.log(err)
            })
        })
        .catch(() => {
          //用户取消
        })
    },
  
  },
}
</script>c
<style scoped lang="scss">
@import '@/styles/config.scss';
</style>
